import { Doc } from '@dadohr/shared/domainTypes/document';
import { IOrganization } from '@dadohr/shared/domainTypes/org';
import { Card, Switch } from '@material-ui/core';
import { orderBy } from 'lodash';
import React from 'react';
import {
  IColumn,
  VirtualizedSortableTable
} from '../../../../../../../components/Table/VirtualizedSortable';
import { SortDirection } from '../../../../../../../hooks/useSort';
import { CanvasBar } from '../../../../../../../layout/Canvas';
import { Section } from '../../../../../../../layout/Section';
import {
  getFeatureList,
  IFeatureListItem,
  setFeature
} from '../../../../../Admin/FeatureFlags/service';

type Props = {
  org: Doc<IOrganization>;
};

const HEIGHT = 500;

type SortKey = 'displayName' | 'category' | 'accessLevel' | 'enabled';

const sortFn = (
  rows: IFeatureListItem[],
  sortBy: SortKey,
  direction: SortDirection
) => {
  return orderBy(
    rows,
    (r: IFeatureListItem) => {
      if (sortBy === 'category') {
        return r.feature.category;
      }
      if (sortBy === 'accessLevel') {
        return r.feature.accessLevel;
      }
      if (sortBy === 'enabled') {
        return r.enabled;
      }
      return r.feature.displayName;
    },
    direction
  );
};

export const Features: React.FC<Props> = ({ org }) => {
  const features = getFeatureList(org.data.features);

  const COLUMNS: IColumn<IFeatureListItem, SortKey>[] = [
    {
      key: 'enabled',
      head: () => 'Status',
      cell: (d) => (
        <Switch
          checked={d.enabled}
          onChange={(ev) => setFeature(org, d.name, ev.target.checked)}
        />
      ),
      align: 'left',
      sortable: true,
      defaultDirection: 'asc',
      width: 100,
      flexGrow: 1
    },
    {
      key: 'displayName',
      head: () => 'Feature',
      cell: (d) => <div>{d.feature.displayName}</div>,
      align: 'left',
      sortable: true,
      defaultDirection: 'asc',
      width: 100,
      flexGrow: 2
    },
    {
      key: 'category',
      head: () => 'Category',
      cell: (d) => <div>{d.feature.category}</div>,
      align: 'left',
      sortable: true,
      defaultDirection: 'asc',
      width: 100,
      flexGrow: 1
    },
    {
      key: 'accessLevel',
      head: () => 'Access',
      cell: (d) => <div>{d.feature.accessLevel}</div>,
      align: 'left',
      sortable: true,
      defaultDirection: 'asc',
      width: 100,
      flexGrow: 1
    }
  ];
  return (
    <Section>
      <CanvasBar>Features</CanvasBar>
      <Card>
        <VirtualizedSortableTable
          rows={features}
          columns={COLUMNS}
          cellProps={undefined}
          height={HEIGHT}
          margin="normal"
          sortFn={sortFn}
          initialSortColumn={
            COLUMNS.find((c) => c.key === 'displayName') ?? COLUMNS[0]
          }
        />
      </Card>
    </Section>
  );
};
